module.exports = __webpack_public_path__ + "img/56.9396cb44.jpg";